import { ginzaxiaomaApiRequest } from '.';
import {
  GetShopSaleIncentiveItemListParams,
  GetShopSaleIncentiveItemListResponse,
  GetShopSaleIncentiveListParams,
  GetShopSaleIncentiveListResponse,
  ShopSaleIncentiveMonth,
} from 'types/shop-sale-incentive';

const BASE_PATH = '/admin/shop-sale-incentive';

export const getShopSaleIncentiveList = (
  params: GetShopSaleIncentiveListParams,
) => {
  return ginzaxiaomaApiRequest.get<GetShopSaleIncentiveListResponse>(
    `${BASE_PATH}/list`,
    { params },
  );
};

export const getShopSaleIncentiveItems = (
  params: GetShopSaleIncentiveItemListParams,
) => {
  return ginzaxiaomaApiRequest.post<GetShopSaleIncentiveItemListResponse>(
    `${BASE_PATH}/items`,
    params,
  );
};

export const calculateShopSaleIncentive = (yearMonth: string) => {
  return ginzaxiaomaApiRequest.post<ShopSaleIncentiveMonth>(
    `${BASE_PATH}/calculate`,
    { yearMonth },
  );
};

export const refreshShopSaleIncentive = (yearMonth: string) => {
  return ginzaxiaomaApiRequest.post<ShopSaleIncentiveMonth>(
    `${BASE_PATH}/refresh`,
    { yearMonth },
  );
};

export const getShopSaleIncentiveById = (id: number) => {
  return ginzaxiaomaApiRequest.get<ShopSaleIncentiveMonth>(
    `${BASE_PATH}/${id}`,
  );
};
